export default {
  access_token: "",
  refresh_token: "",
  userData: {},
  type: "",
  hasChildren: false,
  childrenIds: [],
  childrenData: [], //{ id: _id, name: _name}
  childSelectedId: "",
  childSelectedName: "",
  ChildselectedEmail: "",
  childrenCounter: 0,
  isLogged: false,
  error: false,
  errorMessage: "",
  childDataGetted: false,
  genders: [],
  childFirstTime: true,
  notificationSetup: {},
  theme: 1,
  notifications: [],
  childProfile: {},
  timeZoneList: [],
  timeZone: {},
  childAvatar: {},
  originalParentId: 0
};
